import React from 'react';
import { connect } from 'react-redux';
import Filter from './Filter'
import FilterRange from './FilterRange';
import FilterInput from './FilterInput';
import FilterCheckboxesStatic from './FilterCheckboxesStatic';
import FilterCheckboxes from './FilterCheckboxes';
import CustomSelect from "../Select/CustomSelect"

import {
  FilterModes, innerResetAll,
  selectAttributeFilter,
  rangeAttributeFilter,
  updateResults
} from "../../store/actions";

import {
  buildFinderFilters,
  buildRefineFilters } from "./Utils";

import { buildHeaderArr } from "../Table/Utils";

import { ArrowsRotate } from '../../icons/icons';

const FiltersList = props => {
  const OPEN_FILTERS_ON_START = 3;

  const { refineFilters, selections, searchExecuted, not_recommended_fnd } = props;
  const staticName = 'product_state';

  const changeFilter = (key, value) => {
    props.selectAttributeFilter(key, value);
    props.updateResults(true);
  };

  const rangeFilter = (key, value) => {
    props.rangeAttributeFilter(key, value);
    props.updateResults(true);
  };

  function getSelectFilter(item)
  {
    return item && Object.prototype.hasOwnProperty.call(item, 'key') && (
      <li key={item.key} className="product-finder-aside__item">
        <Filter isOpen={item.isOpen} label={item.label}>
          <div className="product-finder-aside__fieldset">
            <CustomSelect
              isDisabled={props.isFetching}
              selectedValue={Object.prototype.hasOwnProperty.call(selections, item.key) ? selections[item.key] : null}
              selectCustomName={item.key}
              selectCustomLabel={item.label}
              selectCustomOptions={item.values}
              closeMenuOnSelect={false}
              withoutAutoSelect={true}
              noLowerCasePlaceholder={true}
              onSelect={changeFilter}
              placeholder="Select"
              isLabelVisible={false}
              isMulti={true}/>
          </div>
        </Filter>
      </li>
    );
  }

  function getRangeInputFilter(item)
  {
    const value = props.filters.rangeAttributeFilters[item.key];
    return (
      <li key={item.key} className="product-finder-aside__item">
        <FilterInput
          isOpen={item.isOpen}
          label={item.label}
          name={item.key}
          marks={item.valuesRange}
          onValueChange={rangeFilter}
          unit={item.unit}
          currentValue={value}/>
      </li>
    );
  }

  function getRangeSliderFilter(item)
  {
    const value = props.filters.rangeAttributeFilters[item.key];
    return (
      <li key={item.key} className="product-finder-aside__item">
        <FilterRange
          isOpen={item.isOpen}
          label={item.label}
          name={item.key}
          marks={item.valuesRange}
          onValueChange={rangeFilter}
          unit={item.unit}
          currentValue={value}/>
      </li>
    );
  }

  function getCheckboxFilter(item)
  {
    return (
      <li key={item.key} className="product-finder-aside__item">
        <FilterCheckboxes
          isOpen={item.isOpen}
          label={item.label}
          name={item.key}
          selectedValue={Object.prototype.hasOwnProperty.call(selections, item.key) ? selections[item.key] : null}
          options={item.values}
          onCheck={changeFilter}/>
      </li>
    );
  }

  function getStaticCheckboxFilter()
  {
    return (
      <li key={999} className="product-finder-aside__item">
        <FilterCheckboxesStatic
          label="Production status"
          name={staticName}
          selectedValue={Object.prototype.hasOwnProperty.call(selections, staticName) ? selections[staticName] : null}
          nrfndValue={not_recommended_fnd}
          onCheck={changeFilter} />
      </li>
    );
  }

  const renderFilters = () =>
  {
    let n = 0;

    const renderedFilters = refineFilters.map(item => {
      if (!item) {
        return;
      }

      item.isOpen = (n < OPEN_FILTERS_ON_START);
      n++;

      switch (item.filter_type) {
        case 'select':
          return getSelectFilter(item);
        case 'range_input':
          return getRangeInputFilter(item);
        case 'range_slider':
          return getRangeSliderFilter(item);
        case 'checkbox':
          return getCheckboxFilter(item);
        default:
          return getSelectFilter(item);
      }
    });

    renderedFilters.push(getStaticCheckboxFilter());

    return (renderedFilters);
  };

  if (!(refineFilters && searchExecuted)) {
    return null;
  }

  return (
    <aside className="product-finder-aside">
      <ul className="product-finder-aside__list">
        { renderFilters() }
      </ul>
      <footer className="product-finder-aside__footer">
        <button
          className="btn product-finder-aside__cta"
          onClick={() => props.innerResetAll() && props.updateResults(true)}
        >
          <ArrowsRotate />
          <span>Reset filters</span>
        </button>
      </footer>
    </aside>
  )
};

const mapStateToProps = (state) => {
  let refineFilters = false;
  let finderFilters = false;
  let selections = [];
  const not_recommended_fnd = state.parameters.attributeFilters.not_recommended_fnd;
  const count = state.results.count;
  const mode = state.parameters.mode;
  const searchExecuted = state.results.searchExecuted;

  if (Object.prototype.hasOwnProperty.call(state.results.aggregations, 'attributes')) {
    const headerArray = buildHeaderArr(state.results.attributes, {}, state.results.result);
    refineFilters = buildRefineFilters(state.results.aggregations.attributes, state.parameters.attributeFilters, headerArray, state.results.productFinderFilterTypes);
    selections = state.parameters.attributeFilters;
  }

  if (mode === FilterModes.SEARCH_MODE) {
    finderFilters = buildFinderFilters(state.results.aggregations);
  }

  let filters = {
    'filters': state.parameters.filters,
    'attributeFilters': state.parameters.attributeFilters,
    'rangeAttributeFilters': state.parameters.rangeAttributeFilters,
  };

  const attributeSearch = state.parameters.filters.attribute_search;
  const isFetching = state.results.isFetching;

  return { refineFilters, selections, mode, finderFilters, searchExecuted, filters, attributeSearch, isFetching, count, not_recommended_fnd }
};

export default connect(
  mapStateToProps,
  { selectAttributeFilter, innerResetAll, rangeAttributeFilter, updateResults }
)(FiltersList)
